import React from "react";

import "./Home.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { FaEnvelope, FaFacebook, FaGithub, FaLinkedin } from "react-icons/fa";

const Temp = <FontAwesomeIcon icon={faGraduationCap} />;

const Home = () => {
  return (
    <>
      <div className="container">
        <img src={require("../Sanjay.jpeg")} alt="Sanjay" />
        <div className="info">
          <p>
            Hi ,I am Sanjay Sukumaran,a 3rd Year Undergraduate @CSE IIT KANPUR.
            I have tried to explore competitive programming,full stack web
            development(MERN Stack),machine learning,deep learning ,computer
            vision and robotics. I was also part of Robotics Club and Aerial
            Robotics in my second year at college.
          </p>
          <p>
            As part of recreation I like to play cricket,watch youtube
            videos,and listen to songs on spotify.
          </p>
          <div className="addInfo">
            <div className="interests">
              <h1>Interests</h1>
              <ul>
                <li>Competitive Programming</li>
                <li>Web Development</li>
                <li>Machine Learning</li>
                <li>Reading Novels</li>
                <li>Listening to Songs</li>
              </ul>
            </div>
            <div className="education">
              <h1>Education</h1>
              <ul>
                <li> {Temp} Btech in Computer Science and Engineering 2023</li>
                <p>Indian Institute of technology Kanpur</p>
                <li> {Temp} CBSE Class 12th. 2019</li>
                <p> St.Antony's Public School Kottayam</p>
                <li> {Temp} CBSE Class 10th. 2017</li>
                <p>Jawahar Navodaya Vidyalaya Kannur</p>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <section id="Contact">
        <h1>Contact</h1>
        <div className="icons">
          <a href="mailto: sanjaykannu27@gmail.com" target="_blank">
            <FaEnvelope size={60}/>
          </a>
          <a href="https://www.linkedin.com/in/sanjay-sukumaran-8329251a7/" target="_blank">
            <FaLinkedin size={60}/>
          </a>
          <a href="https://github.com/Sanjayso27" target="_blank">
            <FaGithub  size={60}/>
          </a>
          <a href="https://www.facebook.com/sanjay.sukumaran.750/" target="_blank">
            <FaFacebook size={60}/>
          </a>
        </div>
      </section>
    </>
  );
};

export default Home;
